import React, {useCallback, useEffect} from 'react';
import {Button, Flex, Modal} from 'antd';
import {useTranslation} from "react-i18next";
import {LoginViewStore} from "../view-store";
import {useActions, useStepsProps} from "../hooks/useStepsProps";


export const selectMemberModalTranslations = {
    "en": {
        "title": "This email have multiple members, please select one",
    },
    "fi": {
        "title": "Tällä sähköpostilla on useita jäseniä, valitse yksi",
    }
}


export const MemberSelectorContent = ({members, onSelect}) => {
    return (
        <Flex vertical gap={10}>
            {members.map((member) => {
                return (
                    <Button key={member} onClick={() => onSelect(member)}>{member}</Button>
                )
            })}
        </Flex>
    )
}


const selectMember = async (member) => {
    await LoginViewStore.update(s => {
        s.member = member;
        s.email = '';
        s.loginMethod = 'member';
        s.inputValue = member;
        s.selectUsers = false;
        s.users = [];
    });
};

const useSelectUserModal = () => {
    const users = LoginViewStore.useState(s => s.users);
    const selectUsers = LoginViewStore.useState(s => s.selectUsers);
    const selectUsersAction = LoginViewStore.useState(s => s.selectUsersAction);
    //console.log('[[useSelectUserModal]]', {users, selectUsers});
    const {t} = useTranslation(['selectMember']);
    const steps = useStepsProps();
    const onSelect = useCallback(async (member) => {
        await selectMember(member);
        await selectUsersAction(member);

    }, [steps])
    useEffect(() => {

        if (selectUsers) {

            Modal.confirm({
                title: t('title'),
                onCancel() {
                    LoginViewStore.update(s => {
                        s.selectUsers = false;
                        s.users = [];
                    });
                },
                okButtonProps: {disabled: true},
                content: <MemberSelectorContent members={users} onSelect={onSelect}/>,
            });
        } else {
            Modal.destroyAll();
        }

    }, [selectUsers]);
};

export const SelectMemberModal = () => {
    useSelectUserModal();
    return (
        <>
            <Modal/>
        </>
    );
};
